type Props = {
  roomName: string
  address: string
}

export const Header = ({ roomName, address }: Props) => {
  return (
    <section className="mb-10 space-y-2">
      <div className="flex items-center gap-3">
        <h1 className="typo-title2 font-semibold text-black">{roomName}</h1>
      </div>
      <p className="typo-body2 font-normal text-gray-900">{address}</p>
    </section>
  )
}
